import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // Necesario para [(ngModel)]
import { TranslationService } from '../services/translation.service';

@Component({
  selector: 'app-reader',
  standalone: true,
  imports: [CommonModule, FormsModule], // Importamos FormsModule para ngModel
  templateUrl: './reader.component.html',
  styleUrls: ['./reader.component.css']
})
export class ReaderComponent {

  folderName: string = 'paleta';
  images = [
    'obras/paleta/uno.jpg',
    'obras/paleta/dos.png',
    'obras/paleta/tres.png',
  ];

  // Información inicial
  pageInfo = {
    title: 'Snake Ancestor',
    caption: '2',
    views: 1000,
    author: 'Franco Legendari',
    authorInitial: 'F', // Inicial del autor
    subscribers: 188 // Número de suscriptores
  };

  // Capítulos y estilos de vista
  chapters = ['Chapter 1', 'Chapter 2', 'Chapter 3'];
  selectedChapter = 'Chapter 2';
  viewStyle = 'list';
  isFavorite = false;

  constructor(public translationService: TranslationService) {}

  ngOnInit() {
    this.translationService.currentLanguage$.subscribe(() => {
      // Actualizar traducciones si es necesario
    });
  }

  onChapterChange(event: Event) {
    console.log('Capítulo seleccionado:', this.selectedChapter);
  }

  onViewStyleChange(event: Event) {
    console.log('Estilo de vista seleccionado:', this.viewStyle);
  }

  toggleFavorite() {
    this.isFavorite = !this.isFavorite;
    console.log('Favorito:', this.isFavorite);
  }

  previous() {
    console.log('Botón Previous clickeado');
  }

  next() {
    console.log('Botón Next clickeado');
  }
}
